import React, {useState} from 'react'
import {Box, Button, TextField, Chip, Typography} from '@mui/material'
import {Add, Delete} from '@mui/icons-material'

const SpeechContext = ({ speechContext, setSpeechContext }) => {
  const [phrases, setPhrases] = useState({});

  const updateContext = (newContext) => {
    setSpeechContext(newContext);
  };

  const addSpeechContext = () => {
    updateContext([{ boost: 0, phrase: undefined, phrases: [] }, ...speechContext]);
  };

  const removeSpeechContext = (index) => {
    updateContext(speechContext.filter((_, i) => i !== index));

    setPhrases((prev) => {
      const newPhrases = { ...prev };
      delete newPhrases[index]; // Remove stored phrase input
      return newPhrases;
    });
  };

  const updateBoost = (index, boost) => {
    const newContext = [...speechContext];
    newContext[index].boost = boost;

    updateContext(newContext);
  };

  const updatePhrase = (index, phrase) => {
    setPhrases((prev) => ({ ...prev, [index]: phrase }));
  };

  const addPhrase = (index) => {
    const phrase = phrases[index];
    if (!phrase) return; // Prevent adding empty phrases

    const newContext = [...speechContext];
    newContext[index] = {
      ...newContext[index],
      phrases: [...newContext[index].phrases, phrase],
    };

    updateContext(newContext);
    setPhrases((prev) => ({ ...prev, [index]: '' }));
  };

  const removePhrase = (contextIndex, phraseIndex) => {
    const newContext = [...speechContext];
    newContext[contextIndex].phrases.splice(phraseIndex, 1);
    updateContext(newContext);
  };

  const handlePhraseKeyDown = (e, contextIndex) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addPhrase(contextIndex);
    }
  }

  return (
    <Box>
      <Button sx={{mb: 3}} onClick={addSpeechContext} startIcon={<Add />} variant="contained">
        Add Speech Context
      </Button>

      {speechContext.map((item, contextIndex) => (
        <Box key={contextIndex}
             sx={{ border: "1px solid #ccc", p: 3, mb: 4, borderRadius: 1}}>
          <Box sx={{display: 'flex', alignItems: 'center'}}>
            <TextField
              label="Boost"
              type="text"
              value={item.boost}
              variant="standard"
              onChange={(e) => updateBoost(contextIndex, e.target.value.match(/\d+/) ? Number(e.target.value) : "")}
              sx={{ width: "100px", mr: 1 }}
            />
            <Box sx={{position: 'relative', flexGrow: 1, marginLeft: 1}}>
              <TextField
                label="Phrase"
                value={phrases[contextIndex] || ''}
                sx={{width: '100%'}}
                InputProps={{
                  sx: { paddingRight: '64px' }
                }}
                onChange={(e) => updatePhrase(contextIndex, e.target.value)}
                onKeyDown={(e) => handlePhraseKeyDown(e, contextIndex)}
              />
              <Button
                variant="contained"
                onClick={() => addPhrase(contextIndex)}
                sx={
                  {
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    height: '100%',
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    fontSize: 24,
                  }
                }
              >
                +
              </Button>
            </Box>
            <Button sx={{ml: 2, minWidth: 'auto'}}>
              <Delete onClick={() => removeSpeechContext(contextIndex)} color="error" sx={{cursor: 'pointer'}}></Delete>
            </Button>
          </Box>
          {item.phrases.length > 0 && (
            <Typography sx={{mt: 2}}>Phrases</Typography>
          )}
          <Box sx={{mt: item.phrases.length > 0 ? 2 : 0, display: "flex", flexWrap: 'wrap'}}>
            {item.phrases.map((phrase, phraseIndex) => (
              <Chip
                key={phraseIndex} sx={{mb: 1, mr: 1 }}
                label={phrase}
                onDelete={() => removePhrase(contextIndex, phraseIndex)}
                variant="contained"
              />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default SpeechContext;
